import ProPageLayout from './ProPageLayout';

export default ProPageLayout;
